/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskIndicatorTypeShallow } from './RiskIndicatorTypeShallow';
import {
  RiskIndicatorTypeShallowFromJSON,
  RiskIndicatorTypeShallowFromJSONTyped,
  RiskIndicatorTypeShallowToJSON,
} from './RiskIndicatorTypeShallow';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface RiskMetric
 */
export interface RiskMetric {
  /**
   *
   * @type {number}
   * @memberof RiskMetric
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskMetric
   */
  name: string;
  /**
   *
   * @type {RiskIndicatorTypeShallow}
   * @memberof RiskMetric
   */
  readonly indicator: RiskIndicatorTypeShallow;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof RiskMetric
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof RiskMetric
   */
  weight?: number;
  /**
   *
   * @type {boolean}
   * @memberof RiskMetric
   */
  isActive?: boolean;
  /**
   *
   * @type {string}
   * @memberof RiskMetric
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof RiskMetric
   */
  postprocessing?: string;
  /**
   *
   * @type {string}
   * @memberof RiskMetric
   */
  auxiliaryMetrics?: string;
  /**
   *
   * @type {string}
   * @memberof RiskMetric
   */
  infoboxDescription?: string;
  /**
   *
   * @type {Array<Perturbation>}
   * @memberof RiskMetric
   */
  readonly perturbations: Array<Perturbation>;
  /**
   *
   * @type {boolean}
   * @memberof RiskMetric
   */
  readonly availableForAssessment: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof RiskMetric
   */
  readonly unavailabilityReasons: Array<string>;
}

/**
 * Check if a given object implements the RiskMetric interface.
 */
export function instanceOfRiskMetric(value: object): value is RiskMetric {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('indicator' in value) || value['indicator'] === undefined) return false;
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('perturbations' in value) || value['perturbations'] === undefined) return false;
  if (!('availableForAssessment' in value) || value['availableForAssessment'] === undefined) return false;
  if (!('unavailabilityReasons' in value) || value['unavailabilityReasons'] === undefined) return false;
  return true;
}

export function RiskMetricFromJSON(json: any): RiskMetric {
  return RiskMetricFromJSONTyped(json, false);
}

export function RiskMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskMetric {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    indicator: RiskIndicatorTypeShallowFromJSON(json['indicator']),
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    weight: json['weight'] == null ? undefined : json['weight'],
    isActive: json['is_active'] == null ? undefined : json['is_active'],
    description: json['description'] == null ? undefined : json['description'],
    postprocessing: json['postprocessing'] == null ? undefined : json['postprocessing'],
    auxiliaryMetrics: json['auxiliary_metrics'] == null ? undefined : json['auxiliary_metrics'],
    infoboxDescription: json['infobox_description'] == null ? undefined : json['infobox_description'],
    perturbations: (json['perturbations'] as Array<any>).map(PerturbationFromJSON),
    availableForAssessment: json['available_for_assessment'],
    unavailabilityReasons: json['unavailability_reasons'],
  };
}

export function RiskMetricToJSON(
  value?: Omit<
    RiskMetric,
    'id' | 'indicator' | 'perturbations' | 'availableForAssessment' | 'unavailabilityReasons'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    weight: value['weight'],
    is_active: value['isActive'],
    description: value['description'],
    postprocessing: value['postprocessing'],
    auxiliary_metrics: value['auxiliaryMetrics'],
    infobox_description: value['infoboxDescription'],
  };
}
